import { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "tbts_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const consent = localStorage.getItem(STORAGE_KEY);
      if (!consent) {
        const timer = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(timer);
      }
    } catch {
      /* localStorage unavailable */
    }
  }, []);

  const setConsent = (value) => {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch {
      /* ignore */
    }
    if (value === "granted" && typeof window !== "undefined" && window.posthog) {
      try {
        window.posthog.opt_in_capturing();
        if (typeof window.posthog.startSessionRecording === "function") {
          window.posthog.startSessionRecording();
        }
      } catch {
        /* ignore */
      }
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-desc"
      className="fixed bottom-4 left-4 right-4 sm:left-6 sm:bottom-6 sm:right-auto sm:max-w-md z-[60] motion-safe:animate-[fadeInUp_300ms_ease-out]"
    >
      <div className="bg-white rounded-2xl shadow-2xl shadow-slate-900/20 border border-slate-200 p-5">
        <div className="flex items-start gap-3 mb-3">
          <div className="w-10 h-10 bg-emerald-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-emerald-700" aria-hidden="true" />
          </div>
          <div className="flex-1">
            <h2 id="cookie-banner-title" className="text-sm font-bold text-slate-900 mb-1">
              Używamy ciasteczek
            </h2>
            <p id="cookie-banner-desc" className="text-xs text-slate-600 leading-relaxed">
              Używamy plików cookie do analizy ruchu i poprawy działania strony.
              Możesz je zaakceptować lub odrzucić — odrzucenie nie wpływa na działanie formularza kontaktowego.{" "}
              <a
                href="/polityka-prywatnosci"
                className="text-emerald-700 underline hover:text-emerald-800"
              >
                Więcej
              </a>
            </p>
          </div>
          <button
            type="button"
            onClick={() => setConsent("denied")}
            className="text-slate-400 hover:text-slate-700 p-1 -m-1 rounded focus:outline-none focus:ring-2 focus:ring-emerald-500"
            aria-label="Zamknij i odrzuć ciasteczka analityczne"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setConsent("denied")}
            className="flex-1 px-4 py-2.5 text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-slate-400 focus:ring-offset-1"
          >
            Tylko niezbędne
          </button>
          <button
            type="button"
            onClick={() => setConsent("granted")}
            className="flex-1 px-4 py-2.5 text-xs font-semibold text-white bg-emerald-700 hover:bg-emerald-800 rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1"
          >
            Akceptuję wszystkie
          </button>
        </div>
      </div>
    </div>
  );
}
